import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetTicketTypesInput, Result, ResultList, TicketTypeInput, TicketTypeResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class TicketTypeService {

  constructor(private httpClient: HttpClient) { }

  public addTicketType(ticketTypeInput: TicketTypeInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'TicketType/AddTicketType', ticketTypeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editTicketType(id: number, ticketTypeInput: TicketTypeInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'TicketType/EditTicketType?id=' + id, ticketTypeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteTicketType(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'TicketType/DeleteTicketType?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTicketTypes(getTicketTypesInput: GetTicketTypesInput, token: string): Promise<ResultList<TicketTypeResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'TicketType/GetTicketTypes', getTicketTypesInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketTypeResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketTypeResult>(), result.error));
  }
}
